import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Button, Flex, Stack, Text, Title } from "@mantine/core";
import { SvgIcon } from "@mui/material";
export const EmptyState = ({ backgroundIcon, primaryIcon, accentIcon, title, description, action, minHeight = "400px", padding = "2rem", paddingBottom, primaryColor = "var(--mantine-color-primary-9)" }) => {
    return (_jsxs("div", { style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            minHeight: "17.5rem",
            overflow: "hidden",
            backgroundColor: "var(--mantine-color-primary-0)",
        }, children: [_jsx("style", { children: `
          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }
        ` }), _jsxs(Stack, { align: "center", justify: "center", style: {
                    padding,
                    paddingBottom: paddingBottom ?? padding,
                    minHeight,
                    width: "100%"
                }, children: [_jsxs(Flex, { style: {
                            position: "relative",
                            marginBottom: "2rem"
                        }, children: [_jsx(SvgIcon, { component: backgroundIcon, style: {
                                    fontSize: "6rem",
                                    color: alpha(primaryColor, 0.2),
                                    position: "absolute",
                                    transform: "rotate(-10deg)"
                                } }), _jsx(SvgIcon, { component: primaryIcon, style: {
                                    fontSize: "4rem",
                                    color: primaryColor,
                                    position: "relative",
                                    animation: "bounce 2s infinite"
                                } }), accentIcon && (_jsx(SvgIcon, { component: accentIcon, style: {
                                    fontSize: "2rem",
                                    color: primaryColor.replace(", 1)", ", 0.7)"),
                                    position: "absolute",
                                    right: "-1rem",
                                    bottom: "-1rem",
                                    transform: "rotate(15deg)"
                                } }))] }), _jsx(Title, { order: 3, style: { marginBottom: "0.5rem" }, children: title }), _jsx(Text, { variant: "paragraph", style: {
                            color: "var(--mantine-color-gray-6)",
                            textAlign: "center",
                            fontSize: "14px",
                            maxWidth: "400px",
                            marginBottom: "1.5rem"
                        }, children: description }), action && (_jsx(Button, { variant: "filled", onClick: action.onClick, children: action.label }))] })] }));
};
